import React from 'react';
import GradeSelector from '../GradeSelector';
import {Stage, Term} from '../../API/newHome';
import {useSelector} from 'react-redux';
import {selectUserInfo} from '../../store/user';

interface SubjectVersionModalProps {
  visible: boolean;
  onConfirm: (curriculumSetup: any) => void;
  onCancel: () => void;
  nextGrade?: number;
}

const SubjectVersionModal: React.FC<SubjectVersionModalProps> = ({
  visible,
  onConfirm,
  onCancel,
  nextGrade,
}) => {
  const userInfo = useSelector(selectUserInfo);
  const stages = userInfo.stages || [];
  const terms = userInfo.terms || [];

  // 找到目标年级所在的学段
  const targetStage = stages.find(stage =>
    stage.grades.some(grade => Number(grade.id) === nextGrade),
  );

  // 构建初始值
  const initialValues = {
    xkwStageId: targetStage?.id || 0,
    xkwGradeId: nextGrade || 0,
    xkwTerm: '1', // 默认选择上学期
    xkwVersionList:
      targetStage?.courses.map(course => ({
        stage_id: targetStage.id,
        subject_id: course.subject.id,
        course_id: course.id,
        version_id: course.versions[0]?.id || 0, // 默认选择第一个版本
      })) || [],
  };

  return (
    <GradeSelector
      isVisible={visible}
      onClose={onCancel}
      onChange={onConfirm}
      stages={stages}
      terms={terms}
      initialValues={initialValues}
    />
  );
};

export default SubjectVersionModal;
